__turbopack_context__.v({
  "color": "mBRiba_color",
  "compact": "mBRiba_compact",
  "dash": "mBRiba_dash",
  "googleAuth-container": "mBRiba_googleAuth-container",
  "rotate": "mBRiba_rotate",
  "signIn-container": "mBRiba_signIn-container",
  "signIn-container-empty": "mBRiba_signIn-container-empty",
  "spinner-circular": "mBRiba_spinner-circular",
  "spinner-container": "mBRiba_spinner-container",
  "spinner-main": "mBRiba_spinner-main",
  "spinner-path": "mBRiba_spinner-path",
  "spinner-showbox": "mBRiba_spinner-showbox",
});
